import React from 'react';
import { ICON } from '../icons/iconIds';
import IconText from './icons/IconText';
import Layout from './layout/Layout';
import Tabs from './ui/Tabs';
import BrandLibraryTab from './documentDesign/BrandLibraryTab';
import DocumentsTab from './documentDesign/DocumentsTab';
import MediaCreatorTab from './documentDesign/mediaCreator/MediaCreatorTab';
import './DocumentDesign.css';

const TAB_STORAGE_KEY = 'documentDesign.tab';

const DocumentDesign = ({ user }) => {
  const defaultTab = sessionStorage.getItem(TAB_STORAGE_KEY) || 'documents';

  return (
    <Layout user={user} currentRoute="/document-design" fullWidth>
      <div className="document-design">
        <div className="document-design-header">
          <div>
            <IconText icon={ICON.appDocumentDesign} as="h1">Document Design</IconText>
            <p>Turn Word reports into branded Selkirk publications</p>
          </div>
        </div>

        <Tabs
          className="dd-tabs"
          defaultTab={defaultTab}
          onTabChange={(id) => sessionStorage.setItem(TAB_STORAGE_KEY, id)}
          tabs={[
            { id: 'documents', label: 'Documents', iconId: ICON.ddTabDocuments, content: <DocumentsTab /> },
            { id: 'library', label: 'Brand Library', iconId: ICON.ddTabBrandLibrary, content: <BrandLibraryTab /> },
            { id: 'creator', label: 'Media Creator', iconId: ICON.ddTabMediaCreator, content: <MediaCreatorTab /> },
          ]}
        />
      </div>
    </Layout>
  );
};

export default DocumentDesign;
